import { useCallback } from 'react';
import styled from 'styled-components';
import VizExIcon from 'visitor-ui-component-library/icon/VizExIcon';
import SVGClose from 'visitor-ui-component-library-icons/icons/SVGClose';
import SVGSuccess from 'visitor-ui-component-library-icons/icons/SVGSuccess';
import unescapedText from 'I18n/utils/unescapedText';
import { IconButton } from 'conversations-visitor-experience-components/visitor-widget/SpotlightLauncherShell';
import { postMessageToParent } from '../../post-message/postMessageToParent';
import { VOICE_RECORDING_CONFIRM, VOICE_RECORDING_DISCARD } from '../../constants/PostMessageTypes';
import { useAppDispatch } from '../../buildStore';
import { cancelVoiceRecording } from '../reducers/voiceInputSlice';
import { mockTranscribeVoiceInput } from '../actions/mockTranscribeVoiceInput';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ControlsRow = styled.div.withConfig({
  displayName: "VoiceRecordingControls__ControlsRow"
})(["display:flex;gap:8px;align-items:center;flex-shrink:0;margin-left:auto;"]);
const VoiceRecordingControls = ({
  discardDisabled = false,
  confirmDisabled = false,
  hideConfirm = false
}) => {
  const dispatch = useAppDispatch();
  const onDiscard = useCallback(() => {
    postMessageToParent(VOICE_RECORDING_DISCARD);
    dispatch(cancelVoiceRecording());
  }, [dispatch]);
  const onConfirm = useCallback(() => {
    postMessageToParent(VOICE_RECORDING_CONFIRM);
    // TODO: Replace with real transcription flow
    dispatch(mockTranscribeVoiceInput());
  }, [dispatch]);
  return /*#__PURE__*/_jsxs(ControlsRow, {
    children: [/*#__PURE__*/_jsx(IconButton, {
      $active: !discardDisabled && confirmDisabled,
      "aria-label": unescapedText('conversations-visitor-ui.voiceInput.discardRecording'),
      onClick: onDiscard,
      disabled: discardDisabled,
      children: /*#__PURE__*/_jsx(VizExIcon, {
        size: "14px",
        icon: /*#__PURE__*/_jsx(SVGClose, {})
      })
    }), !hideConfirm && /*#__PURE__*/_jsx(IconButton, {
      $active: !confirmDisabled,
      "aria-label": unescapedText('conversations-visitor-ui.voiceInput.confirmRecording'),
      onClick: onConfirm,
      disabled: confirmDisabled,
      children: /*#__PURE__*/_jsx(VizExIcon, {
        size: "14px",
        icon: /*#__PURE__*/_jsx(SVGSuccess, {})
      })
    })]
  });
};
VoiceRecordingControls.displayName = 'VoiceRecordingControls';
export default VoiceRecordingControls;